import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  forgotPasswordController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$window',
    'authService',
    '$state',
    '$filter',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $window,
      authService,
      $state,
      $filter
    ) {
      'use strict';

      function keyPress(e) {
        // keyCode == ENTER
        if (e.keyCode === 13) {
          $scope.requestRecoverPassword();
        }
      }

      function is390Visible() {
        var width = $window.innerWidth;
        return width > 767 || (width <= 600 && width > 500);
      }

      function is500Visible() {
        var width = $window.innerWidth;
        return width <= 767 && width > 600;
      }

      function is300Visible() {
        var width = $window.innerWidth;
        return width <= 500 && width > 400;
      }

      function is220Visible() {
        var width = $window.innerWidth;
        return width <= 400;
      }

      function requestRecoverPassword() {
        authService
          .forgotPassword($scope.forgotPassword.email)
          .then(function () {
            $state.go('requestPasswordInfo');
          })
          .catch(function (error) {
            swal.fire({
              title: $filter('translate')('UNEXPECTED ERROR'),
              text: error,
              icon: 'warning',
              showCancelButton: false,
              closeOnConfirm: false,
            });
          });
      }

      function run() {
        try {
          $rootScope.onLogin = true;
          $rootScope.title = 'Recuperação de Senha';
          $scope.forgotPassword = { email: null };

          if ($state && $state.params && $state.params.email) {
            $scope.forgotPassword.email = $state.params.email;
          }

          $scope.idle = false;

          $scope.keyPress = logWrapper(
            keyPress,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.is390Visible = logWrapper(
            is390Visible,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.is500Visible = logWrapper(
            is500Visible,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.is300Visible = logWrapper(
            is300Visible,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.is220Visible = logWrapper(
            is220Visible,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.requestRecoverPassword = logWrapper(
            requestRecoverPassword,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
